/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".nsc-order-confirmation__requestor[_ngcontent-%COMP%]{line-height:1.75;color:#4f4f4f}.nsc-order-confirmation__requestor[_ngcontent-%COMP%]   em[_ngcontent-%COMP%]{font-weight:500;font-style:normal}.nsc-order-confirmation__requestor[_ngcontent-%COMP%]   strong[_ngcontent-%COMP%]{font-weight:700;font-style:normal;color:#000}"];
export { styles as styles };
